import { render, staticRenderFns } from "./Instances.vue?vue&type=template&id=b574548e&scoped=true"
import script from "./Instances.vue?vue&type=script&lang=js"
export * from "./Instances.vue?vue&type=script&lang=js"
import style0 from "./Instances.vue?vue&type=style&index=0&id=b574548e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b574548e",
  null
  
)

export default component.exports